import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import { LoadScript } from "@react-google-maps/api";
import "./App.css";
import { Spin } from "antd";

const GOOGLE_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  "AIzaSyCKTviQfOK1UR9IRMbiIYsLgWlKZUdU9rc";

const App: React.FC = () => {
  return (
    <LoadScript
      googleMapsApiKey={GOOGLE_API_KEY}
      libraries={["places"]}
      loadingElement={
        <div className="flex items-center justify-center h-screen w-screen bg-white">
          <Spin size="large" />
        </div>
      }
    >
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          pauseOnFocusLoss
          limit={1}
        />
        <AppRoutes />
      </Router>
    </LoadScript>
  );
};

export default App;
